// extracted by mini-css-extract-plugin
module.exports = {"tabBar":"tabBar_tabBar__amlow","tab":"tabBar_tab__7_pew","tab__active":"tabBar_tab__active__LoS8U","tab__disabled":"tabBar_tab__disabled___rJdn"};